module.exports = __webpack_public_path__ + "img/product-program-dzjqr-bottom.fe661a51.png";